import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { useTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/styles';
import { combineStyles, isGranted } from 'helpers/helpers';
import { useState } from 'react';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import DataGrid from 'components/DataGrid/DataGrid';
import AdminTable from 'layouts/AdminTable';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import { put, get } from 'helpers/apiHelpers';
import { compose } from 'redux';
import { connect } from 'react-redux';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { useEffect } from 'react';
import {
  ROLE_REMOVE_BLOG_POST,
  ROLE_EDIT_BLOG_POST,
  ROLE_CREATE_BLOG_POST,
} from 'helpers/roles';
import PresentationUrl from 'components/CMS/PresentationUrl';
import SEOSettingsCms from 'views/SEO/SEOSettingsCms';
import CardWrapper from 'components/Card/CardWrapper';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import { toast } from 'react-toastify';

import columnConfig from './columnConfig';
import Banner from '../HomePage/Banner';

const initialState = {
  showBlogPage: false,
  enabled: false,
  content: '',
  heading: '',
  bannerDesktop: null,
  bannerDesktopUrl: null,
  bannerMobile: null,
  bannerMobileUrl: null,
  image: null,
  imageUrl: null,
  indexing: false,
  marketingTitle: '',
  metaDescription: '',
  openGraphDescription: '',
  openGraphTitle: '',
};

const Blog = ({ classes, selectedBrand, history }) => {
  const { t } = useTranslation();
  const [state, setState] = useState(initialState);

  const newPost = () => history.push(`${window.location.pathname}/add`);
  const [enabledStateWithApi, setEnabledStateWithApi] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get(`brands/${selectedBrand}/modules`).then(response => {
      // eslint-disable-next-line no-shadow, no-unsafe-optional-chaining -- FIXME
      const { Blog } = response?.configuration;
      setState(prev => ({
        ...prev,
        showBlogPage: Blog?.showBlogPage,
        enabled: Blog?.enabled,
        content: Blog?.content,
        heading: Blog?.heading,
        bannerDesktop: Blog?.bannerDesktop,
        bannerDesktopUrl: Blog?.bannerDesktopUrl,
        bannerMobile: Blog?.bannerMobile,
        bannerMobileUrl: Blog?.bannerMobileUrl,
        image: Blog?.image,
        imageUrl: Blog?.imageUrl,
        indexing: Blog?.indexing,
        marketingTitle: Blog?.marketingTitle,
        metaDescription: Blog?.metaDescription,
        openGraphDescription: Blog?.openGraphDescription,
        openGraphTitle: Blog?.openGraphTitle,
      }));
      setEnabledStateWithApi(Blog?.enabled);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  const handleSubmit = () => {
    put(`brands/${selectedBrand}/modules`, {
      configuration: {
        Blog: {
          showBlogPage: state?.showBlogPage,
          enabled: state?.enabled,
          content: state?.content,
          heading: state?.heading,
          bannerDesktop: state?.bannerDesktop,
          bannerDesktopUrl: state?.bannerDesktopUrl,
          bannerMobile: state?.bannerMobile,
          bannerMobileUrl: state?.bannerMobileUrl,
          image: state?.image,
          imageUrl: state?.imageUrl,
          indexing: state?.indexing,
          marketingTitle: state?.marketingTitle,
          metaDescription: state?.metaDescription,
          openGraphDescription: state?.openGraphDescription,
          openGraphTitle: state?.openGraphTitle,
        },
      },
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(() => {
      toast.success(t('status.success.save'));
    });
  };

  return (
    <>
      <CardWrapper title={t('form.basicInfo')}>
        <CardBody>
          <GridContainer>
            <GridItem md={12}>
              <LabeledCheckbox
                name="active"
                onClick={() =>
                  setState(prev => ({
                    ...prev,
                    showBlogPage: !state.showBlogPage,
                  }))
                }
                checked={state.showBlogPage}
                label={<div>{t('cms.homePage.showHomePage')} </div>}
              />
            </GridItem>
            {state?.enabled && (
              <GridItem xs={12}>
                <PresentationUrl
                  subpage="/blog"
                  cmsShowActionButton={enabledStateWithApi}
                />
              </GridItem>
            )}
          </GridContainer>
        </CardBody>
      </CardWrapper>

      <Banner number={1} state={state} setState={setState} page="blog" />

      <AdminTable title={t('blog.list')}>
        {isGranted(ROLE_CREATE_BLOG_POST) && (
          <FormControlButtons
            classes={classes}
            handleSubmit={() => {
              newPost();
            }}
            submitText={`${t('blog.addPost')}+`}
          />
        )}
        <DataGrid
          actions={true}
          editPath={
            isGranted(ROLE_EDIT_BLOG_POST) && `${window.location.pathname}/edit`
          }
          remove={isGranted(ROLE_REMOVE_BLOG_POST)}
          export={true}
          paginationTop={true}
          paginationBottom={false}
          url="/blog-posts"
          reportName="blogpost"
          columns={columnConfig}
          role="BLOG"
          minRows={20}
          defaultSorted={[{ id: 'position', desc: false }]}
        />
      </AdminTable>
      <SEOSettingsCms
        state={state}
        setState={setState}
        moduleConfiguration={false}
        classes={classes}
        section="Blog"
      />
      {isGranted(ROLE_EDIT_BLOG_POST) && (
        <FormControlButtons
          classes={classes}
          submitText={t('form.save')}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

const mapStateToProps = state => ({
  selectedBrand: state.Auth.selectedBrand,
});
const enchance = compose(
  connect(mapStateToProps, {}),
  withStyles(combineStyles(extendedFormsStyle))
);
export default enchance(Blog);
